import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Toaster } from 'sonner';
import { LanguageProvider } from './contexts/LanguageContext';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { CookieConsent } from './components/CookieConsent';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Fleets } from './pages/Fleets';
import { Careers } from './pages/Careers';
import { Contact } from './pages/Contact';
import { Admin } from './pages/Admin';
import './App.css';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Layout wrapper for public pages
function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <div className="flex-1">{children}</div>
      <Footer />
      <CookieConsent />
    </>
  );
}

function App() {
  const location = window.location.pathname;
  const isAdminPage = location === '/admin';

  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App min-h-screen bg-slate-50 flex flex-col">
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
            <Route path="/fleets" element={<PublicLayout><Fleets /></PublicLayout>} />
            <Route path="/careers" element={<PublicLayout><Careers /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
          </Routes>
        </div>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: '#0A192F',
              color: '#E2E8F0',
              border: 'none',
            },
          }}
        />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
